import React, { ReactNode } from "react";

import { NavLink, useLocation } from "react-router-dom";
import "./tabBar.scss";

// Define an interface for the props
interface TabBarItem {
  path: string;
  title: string;
}

interface TabBarProps {
  items?: TabBarItem[];
  children?: ReactNode;
  title?: string;
}
function modifyRoute(route: any) {
  if (route.startsWith("/")) {
    route = route.slice(1);
  }
  return route
    .split("/")
    .map((segment: any) =>
      segment
        .split("-")
        .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    )
    .join("/");
}
function TabBar({ items, children, title }: TabBarProps) {
  const { pathname } = useLocation();
  const modifiedRoute = modifyRoute(pathname);

  return (
    <>
      {/* <p>{modifiedRoute}</p> */}
      <div className="tabbar">
        <h3>{title}</h3>
        <div className="tabbar_container">
          {children ?? <div></div>}
          <div className="routes">
            {items
              ? items?.map((item, i) => {
                  if (!item.path.includes(":")) {
                    return (
                      <NavLink
                        key={i}
                        to={item.path}
                        className={({ isActive }) =>
                          isActive ? "nav-list nav-list-active" : "nav-list"
                        }
                      >
                        {item.title}
                      </NavLink>
                    );
                  }
                  return null;
                })
              : null}
          </div>
        </div>
      </div>
    </>
  );
}

export default TabBar;
